<template>
  <div>
    <progress-bar v-if="showProgressBarOnForm" class="mb-4" />
    <recent-signatures v-if="recentActions.length" :recent-actions="recentActions" />
    <hr-full-width v-if="show" class="my-4" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import HrFullWidth from '../../campaign-action-shared/hr-full-width'
import ProgressBar from './progress-bar'
import RecentSignatures from './recent-signatures'

export default {
  components: { HrFullWidth, ProgressBar, RecentSignatures },

  computed: {
    ...mapGetters(['showProgressBarOnForm']),
    ...mapState(['recentActions']),

    show() {
      return this.showProgressBarOnForm || this.recentActions.length
    }
  }
}
</script>
